"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldImage = /*#__PURE__*/function (_Entry$Field) {
  function FieldImage(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldImage);
    _this = _callSuper(this, FieldImage, [content, blockView, index]);
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this._content = content;
    var box = new Entry.BoxModel();
    _this.box = box;
    if (Entry.Utils.isNumber(content.size)) {
      _this._width = content.size;
      _this._height = content.size;
    } else {
      var sizeSet = content.size || {};
      _this._width = sizeSet.width || 0;
      _this._height = sizeSet.height || 0;
    }
    _this._highlightColor = content.highlightColor || '#F59900';
    _this._position = content.position;
    _this.svgGroup = null;
    _this._path = null;
    _this._imgElement = null;
    _this._index = index;
    _this.setValue(null);
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldImage, _Entry$Field);
  return (0, _createClass2["default"])(FieldImage, [{
    key: "renderStart",
    value: function renderStart() {
      var img = this._content.img;
      this._imgUrl = this._block.deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN ? img.replace('.png', '_un.png') : img;
      var options = {
        href: this._imgUrl,
        x: 0,
        y: this._height * -0.5,
        width: this._width,
        height: this._height
      };
      if (!this._imgElement) {
        this.svgGroup = this._imgElement = this._blockView.contentSvgGroup.elem('image', options);
      } else {
        this._imgElement.attr(options);
      }
      this.box.set({
        x: this._width,
        y: 0,
        width: this._width,
        height: this._height
      });
    }
  }]);
}(Entry.Field);